export default __webpack_public_path__ + "static/media/nft_image_6.2eb2ee26.png";